import { useTranslations } from 'next-intl'
import Image from 'next/image'

const TravelInformationBanner = () => {
	const t = useTranslations('Main.travelInfo')

	return (
		<section className="travel-info-banner">
			{/* <Image
				src={'/images/phone-app.png'}
				alt={'Phone app'}
				width={383}
				height={514}
				className="travel-info-banner__phone-image"
				unoptimized
			/> */}
			<div className="travel-info-banner__container relative">
				<div className="travel-info-banner__wrapper">
					<div className="image-overlay"></div>
					<div
						
						className="travel-info-banner__image"
						style={{
							// backgroundImage: `url(/images/background-2.webp)`,
							// backgroundSize: 'cover',
						}}
					>
						<div dangerouslySetInnerHTML={{ __html: t.raw('hotelExperience') }}>

						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default TravelInformationBanner
